<template>
    <div>
        <navBox></navBox>
        <div class="banner">
            <img src="https://www-api.multi-metaverse.com:81/uploads/20221222/pic/qGDb2w9vUZhjZ1tdrliYQ6qWHOrghwglFLMvxBya.png" alt="" />
        </div>

        <subNav></subNav>
        <div class="relationsContact">
            <div class="wrap">
                <div class="update">Data update in progress</div>
                       </div>
        </div>
        <!-- <mapBox></mapBox> -->
        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footerBox/footerBox";
import navBox from "@/components/navBox/navBox";
import subNav from "@/components/subNav/subNav";
import mapBox from "@/components/mapBox/mapBox";
export default {
    name: "relationsContact",
    components: { footerBox, navBox, subNav, mapBox },
    data() {
        return {
           
        };
    },
};
</script>
<style lang="less" scoped>
.wrap {
    width: 1200px;
    margin: 0 auto;
}

/*banner*/
.banner img {
    width: 100%;
    // height: 220px;
}
//内容
.update{
    text-align: center;
    height: 200px;
    line-height: 200px;
    font-size: 30px;
    font-weight: bold;
    color: gray;
    font-family: 'Lucida Bright';
}
</style>